import { InvoiceStatus } from "@remi/enums/invoice-status";

import { hasCapability, type User } from "../base";
import { NON_EXISTENT_ID } from "../utils/types";

export const invoiceWhere = (user: User) => {
  return hasCapability(user, "invoice.read")
    ? { status: { notIn: [InvoiceStatus.VOIDED] }, deletedAt: null }
    : { AND: [{ id: NON_EXISTENT_ID }] };
};

export const invoice = {
  create: (user: User) => hasCapability(user, "invoice.create"),
  read: (user: User) => hasCapability(user, "invoice.read"),
  viewSummary: (user: User) => hasCapability(user, "invoice.viewSummary"),
  void: (user: User) => hasCapability(user, "invoice.void"),
  delete: (user: User) => hasCapability(user, "invoice.delete"),
};
